import { schema } from 'normalizr';
import { concat } from 'lodash';

// Schema for player_questionnaire
const answer = new schema.Entity('answers');

const responseType = new schema.Entity('responseTypes',
  { answer: answer },
  {
    mergeStrategy: (entityA, entityB) => ({
      ...entityA,
      ...entityB,
      answer:  { parent: entityA.answer, teacher: entityB.answer },
    }),
  }
);

const question = new schema.Entity('questions',
  { responseTypes: [ responseType ] },
  {
    mergeStrategy: (entityA, entityB) => ({
      ...entityA,
      ...entityB,
      notesIds: concat(entityA.notesIds, entityB.notesIds),
    }),
  }
);

const section = new schema.Entity('sections',
  { questions: [question] },
  {
    mergeStrategy: (entityA, entityB) => ({
      ...entityA,
      ...entityB,
      score:  { parent: entityA.score, teacher: entityB.score },
    }),
  }
);

const questionnaire = new schema.Entity('questionnaires', {
  sections: [ section ],
});

const survey = new schema.Entity('surveys', {
  questionnaire: questionnaire,
  sections: [ section ],
  questions: [ question ],
  answers: [ answer ],
});

const playerSurvey = { questionnaires: {
  parent: survey,
  teacher: survey,
}};

const webNote = new schema.Entity('notes');
const webNoteQuestion = new schema.Entity('questions',
  { notes: [webNote] },
  {
    idAttribute: 'asqQuestionId',
    mergeStrategy: (entityA, entityB) => ({
      notes:  concat(entityA.notes, entityB.notes),
    }),
    processStrategy: (entity) => ({ notes: [entity] }),
  }
);
const webNotes = new schema.Array(webNoteQuestion);

// Schemas for some Sparkler API responses.
export const Schemas = {
  SURVEY: survey,
  PLAYER_SURVEY: playerSurvey,
  WEB_NOTES: webNotes,
}
